export default __webpack_public_path__ + "static/media/p17.41bc0b4e.jpeg";